import { useMutation, useQueryClient } from '@tanstack/react-query'

import { showErrorToast } from 'common/api/helpers'
import { successToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { editLanguageRule } from '../api'
import { languageRulesKeys } from '../queryKeys'

const useEditLanguageRuleMutation = () => {
  const queryClient = useQueryClient()

  const accountId = useAppSelector((state) => state.authStates.accountId)

  return useMutation({
    mutationFn: editLanguageRule,
    onSuccess: () => {
      successToast('Language rule has been successfully edited')

      queryClient.invalidateQueries({
        queryKey: languageRulesKeys.list(accountId),
      })
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export default useEditLanguageRuleMutation
